import React from 'react';

import {Link} from 'react-router-dom';
import {takeLatest, takeEvery, call, put} from 'redux-saga/effects';

import {
  getLikedContentSuccess,
  getLikedContentError,
  createLikedContentRequestSuccess,
  createLikedContentRequestError,
  deleteLikedContentRequestSuccess,
  deleteLikedContentRequestError,
  createMessage,
  deleteMessage,
} from 'modulesV2/actions';
import * as types from 'modulesV2/constants';
import {ContentLikeApi} from 'static/three-oh/src/modules/apis';
import {
  LIKE_SUCCESS_MESSAGE,
  UNLIKE_SUCCESS_MESSAGE,
  LIKE_ERROR_MESSAGE,
  UNLIKE_ERROR_MESSAGE,
} from 'static/three-oh/src/modules/constants/messagesCopy';


/**
 * Fetch list of users liked articles and save it in the store
 * @returns {Generator}
 */
function * getLikedContent() {
  try {
    const response = yield call(ContentLikeApi.get);
    yield put(getLikedContentSuccess(response));
  } catch (error) {
    yield put(getLikedContentError(error));
  }
}

function * createNewLikedContent(action) {
  const link = '/my-content/?tab=saved-by-you';

  try {
    const data = yield call(ContentLikeApi.save, action.contentId);
    yield put(createLikedContentRequestSuccess(data));
    yield put(createMessage({
      text: LIKE_SUCCESS_MESSAGE,
      status: 'success',
      action: (
        <Link
          to={link}
          onClick={() => {
            deleteMessage();
          }}
        >
          View
        </Link>
      ),
      duration: 'medium',
    }));
  } catch (error) {
    yield put(createLikedContentRequestError(error));
    yield put(createMessage({
      text: LIKE_ERROR_MESSAGE,
      status: 'danger',
    }));
  }
}

function * deleteLikedContent(action) {
  try {
    yield call(ContentLikeApi.delete, action.likeId);
    yield put(deleteLikedContentRequestSuccess(action.likeId));
    yield put(createMessage({
      text: UNLIKE_SUCCESS_MESSAGE,
      status: 'info',
    }));
  } catch (error) {
    yield put(deleteLikedContentRequestError(error));
    yield put(createMessage({
      text: UNLIKE_ERROR_MESSAGE,
      status: 'danger',
    }));
  }
}

export function * watchCreateLikedContent() {
  yield takeEvery(types.CREATE_LIKED_CONTENT_REQUEST, createNewLikedContent);
}

export function * watchDeleteLikedContent() {
  yield takeEvery(types.DELETE_LIKED_CONTENT_REQUEST, deleteLikedContent);
}

export function * watchGetLikedContent() {
  yield takeLatest(types.GET_LIKED_CONTENT_REQUEST, getLikedContent);
}
